import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yffkzrfy9m: FaireBrandEntity = {
  token: "b_yffkzrfy9m",
  type: "brand",
  name: "Modek Sports",
  avatarUrl:
    "https://cdn.faire.com/fastly/92ff6d1d15ea1c6e25c0fd93eebfd4f9552e4adff61c850c62abf729d2e6d08f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3ec650e495f611ec7cce5773e280cf15256fb844de8409c1a739c203522ebd69.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/92ff6d1d15ea1c6e25c0fd93eebfd4f9552e4adff61c850c62abf729d2e6d08f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3ec650e495f611ec7cce5773e280cf15256fb844de8409c1a739c203522ebd69.webp",
  location: "hollywood, FL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 74,
  isTopShop: true,
  isInsider: true,
  description:
    "Modek Sports is a wholesale supplier focused on fun, high-quality toys, beach goods, and novelty products designed for retail success. Built from years of hands-on experience in both retail and importing, we understand what sells on the floor and what customers actually reach for. Our goal is simple — offer well-made products at competitive pricing with reliable inventory and fast fulfillment. From scooters and die-cast toys to beach and outdoor essentials, Modek Sports helps retailers bring exciting, high-margin items to their stores.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:18.803Z",
    importedBy: "entity-db-cli",
  },
};
